import { FilledInput, FormControl, FormHelperText, InputLabel, MenuItem, Select, styled } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const StyledFormControl = styled(FormControl)({
    minWidth: '100%',
    marginTop: 16,
    marginBottom: 8
});

const StyledMenuItem = styled(MenuItem)({
    paddingTop: 4,
    paddingBottom: 4
});

const StyledInputLabel = styled(InputLabel)({
    transform: 'translate(12px, -15px) scale(0.75)'
});

const StyledFilledInput = styled(FilledInput)({
    height: 30,
    fontSize: '0.65rem',
    paddingBottom: 16
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
        }
    }
};

const MultiSelectComponent = ({ disabled, schema, input, label, meta }) => {
    const { allowBlank, formData } = schema;
    const value = Array.isArray(input.value) ? input.value : [];

    return (
        <StyledFormControl disabled={disabled} error={meta.touched && !!meta.error} variant="filled">
            <StyledInputLabel htmlFor="filled-multiselect" shrink>
                {label}
            </StyledInputLabel>
            <Select
                input={<StyledFilledInput id="filled-multiselect"/>}
                MenuProps={MenuProps}
                multiple
                onChange={input.onChange}
                value={value}
            >
                {allowBlank && <StyledMenuItem key="" value=""/>}
                {formData.map(item => (
                    <StyledMenuItem key={item.id} value={item.id}>
                        {item.name}
                    </StyledMenuItem>
                ))}
            </Select>
            {meta.touched && !!meta.error && (
                <FormHelperText error>{meta.error}</FormHelperText>
            )}
        </StyledFormControl>
    );
};

MultiSelectComponent.propTypes = {
    disabled: PropTypes.bool,
    schema: PropTypes.object.isRequired,
    input: PropTypes.object.isRequired, // Injected by Redux Forms
    label: PropTypes.string,
    meta: PropTypes.object // Injected by Redux Forms
};

export default MultiSelectComponent;
